import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "tooltip_4684759d3555bf6b9a1e628d41cc64d3",
  "use": "tooltip_4684759d3555bf6b9a1e628d41cc64d3-usage",
  "viewBox": "0 0 40 51",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 51\" id=\"tooltip_4684759d3555bf6b9a1e628d41cc64d3\">\n    <path fill-rule=\"evenodd\" d=\"M21.5 50.077c-.5 1.23-2.25 1.23-2.875 0-3.125-7.26-10.5-14.272-12.75-16.487C2.125 29.899 0 24.854 0 19.686 0 8.86 9 0 20 0s20 8.859 20 19.686c0 5.168-2.125 10.213-5.875 13.904-2.125 2.215-9.5 9.228-12.625 16.487z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id